import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

interface StyledSwitchContainerProps {
  disabled?: boolean;
  isToggle?: boolean;
  color?: string;
}

interface StyledOuterContainerProp {
  justifyContent?: string;
}
export const StyledOuterContainer = styled.div<StyledOuterContainerProp>`
  display: flex;
  justify-content: ${({ justifyContent = "flex-start" }) => justifyContent};
`;

export const StyledSwitchContainer = styled.div<StyledSwitchContainerProps>`
  width: 58px;
  height: 26px;

  display: flex;
  position: relative;

  background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertinary};

  transition: background-color 0.2s ease;
  box-shadow: 0px 0px 6px 0px #6f6f6f;

  ${({ isToggle, color }) => {
    return (
      isToggle &&
      `background-color: ${color};
    transition: transform 0.3s ease;`
    );
  }};

  ${({ disabled }) => disabled && `pointer-events: none;`};
  cursor: pointer;

  border-radius: 28px;
`;

export const StyledRoundSwitch = styled.div<{ isToggle?: boolean }>`
  width: 19px;
  height: 19px;

  left: 5px;
  bottom: 4px;

  position: absolute;

  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.primaryAkbankWhite};
  transition: all 0.4s ease 0s;

  border-radius: 50%;

  ${({ isToggle }) => {
    return isToggle && `transform: translateX(25px);`;
  }};

  @media ${MEDIA_QUERIES.MOBILE} {
    bottom: 4px;
  }
`;

export const StyledTextWrapper = styled.div`
  dispaly: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;

  margin-right: 8px;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 16px;
  font-weight: 600;

  pointer-events: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 13px;
  }
`;

export const StyledDescription = styled.div`
  display: flex;
  align-items: center;

  margin-right: 8px;

  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  font-family: "Campton";
  font-size: 13px;
  font-weight: 300;

  pointer-events: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 10px;
  }
`;
